import { AnyAction } from 'redux';

import * as constants from 'redux/constants/roles.constants';
import { ITableUpdate } from 'types/table.types';
import { IRolesFormData } from 'views/RolesView/components/RolesForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.ROLES_ON_DELETE_REQUESTED,
  id,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.ROLES_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetForm = (): AnyAction => ({
  type: constants.ROLES_ON_GET_FORM_REQUESTED,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.ROLES_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: IRolesFormData, id?: string): AnyAction => ({
  type: constants.ROLES_ON_SAVE_REQUESTED,
  formData,
  id,
});
